/***
 * the enum for the types of program
 */

export const Types = {
  Open: "שיעור פתוח",
  Year: "תכנית שנתית",
  Both: "גם וגם",
};
